<template>
	<div style="overflow-x: hidden;overflow-y: hidden;">
		<!-- <navbar></navbar> -->
		<div id="box">
			<el-table id="table"
				:data="tmpnoticelist.filter(data => !search || data.title.toLowerCase().includes(search.toLowerCase()))"
				style="width: 90%;margin: auto;padding-top: 3%;">
				<el-table-column label="time" prop="time" >
				</el-table-column>
				<el-table-column label="type" prop="type">
				</el-table-column>
				<el-table-column label="title" prop="title" >
				</el-table-column>
				<el-table-column align="right">
					<template slot="header" slot-scope="scope">
						<el-input v-model="search" size="mini" placeholder="输入关键字搜索" />
					</template>
					<template slot-scope="scope">
						
						 <el-link style="float: left; color:#409eff ;" @click="todetail(scope.row)"><i class="el-icon-view el-icon--right"></i> {{$t('noticelist.check')}}</el-link>
					</template>
				</el-table-column>
			</el-table>
			<div class="block">

				<el-pagination @size-change="SizeChange" @current-change="CurrentChange"
					:current-page="currentChangePage" :page-size="pageSize" :page-sizes="[15, 25, 50]"
					layout="total,sizes, prev, pager, next" :total="totalnotice">
				</el-pagination>
			</div>

		</div>

	</div>
</template>

<script>
	// 
	// if("XMR"===coin){
	// 	import xmr from './Markdown/XMR.md'
	// }else if("ETH"===coin){
	// 	import xmr from './Markdown/XMR.md'
	// }
	import footerbar from '../../toolbar/footer.vue';
	import navbar from '../../toolbar/navbar.vue'
	var axios = require('axios');
	export default {
		data() {
			return {
				title: "",
				content: "",
				time: "",
				type: "",
				tableData: [],
				search: '',
				pageSize: 15,
				tmpnoticelist: [],
				totalnotice: 0,
				noticecurrentPage: 1,
				token:'',
				currentPage:null

			}

		},
		components: {
			footerbar,
			navbar,

		},
		created() {
			this.token = localStorage.getItem("token")
			this.initNoticeList()
		},
		mounted() {
			
		},
		methods: {
			todetail(obj){
				this.$router.push({name:"notice",params:{id:obj.id,title:obj.title,content:obj.content,time:obj.time},query:{id:obj.id}})
				// console.log(obj.id,obj.title,)
			},
			initNoticeList() {
				let that = this

				var config = {
					method: 'get',
					url: 'http://127.0.0.1:8082/v1/readMessage',
					headers: {
						'token': this.token
					}
				};

				axios(config)
					.then(function(response) {
						that.totalnotice = response.data.data.length
						console.log(response.data)
						for(var item in  response.data.data){
							response.data.data[item].time=response.data.data[item].time.slice(0,response.data.data[item].time.length-2)
							if(response.data.data[item].type===0){
								response.data.data[item].type=that.$t('noticelist.personalnotice')
							}else if(response.data.data[item].type===1){
								response.data.data[item].type=that.$t('noticelist.systemnotice')
							}
						}
						that.tableData = response.data.data
						localStorage.setItem("noticeList",JSON.stringify(response.data.data))
						that.CurrentChange(1)
						//console.log(JSON.stringify(response.data));
					})
					.catch(function(error) {
						console.log(error);
					});

			},
			SizeChange: function(pageSize) {
				// 每页条数切换

				this.pageSize = pageSize;
				this.CurrentChange(this.noticecurrentPage);

			},
			CurrentChange: function(currentPage1) {
				// console.log("1",currentPage1)
				//页码切换
				this.noticecurrentPage = currentPage1;
				this.currentChangePage(this.tableData, currentPage1);
			},
			//分页方法（重点）
			currentChangePage(list, currentPage1) {
				
				let from = (currentPage1 - 1) * this.pageSize;
				let to = currentPage1 * this.pageSize;
				
				this.tmpnoticelist = [];
				for (; from < to; from++) {
					
					if (list[from]) {
						this.tmpnoticelist.push(list[from]);
					}
				}
			},
		}

	};
</script>

<style scoped>
	#box {
		background-color: white;
		width: 70%;
		margin: auto;
		margin-top: 5rem;
		padding-bottom: 2.5rem;
		margin-bottom: 5rem;
		border-radius: 0.5rem;
		box-shadow: 1px 0px 7px 1px rgba(0, 0, 0, .1);
		-webkit-box-shadow: 1px 0px 7px 1px rgba(0, 0, 0, .1);
	}

	@media screen and (max-width: 768px) {
		#table {
			width: 100%;
			margin: auto;
			padding-top: 3%;
		}

		#box {
			background-color: white;
			width: 100%;
			margin: auto;
			margin-top: 5rem;
			padding-bottom: 2.5rem;
			margin-bottom: 5rem;
			border-radius: 0.5rem;
			box-shadow: 1px 0px 7px 1px rgba(0, 0, 0, .1);
			-webkit-box-shadow: 1px 0px 7px 1px rgba(0, 0, 0, .1);
		}
	}
</style>
